<template>
    <datepicker
        ref="datepicker"
        :monday-first="true"
        :bootstrap-styling="true"
        :calendar-button="calendarButton"
        :calendar-button-icon="calendarButtonIcon"
        :language="datepickerFrLanguage"
        :format="attrs['format'] || customFormatter"

        v-on="listeners"
        v-bind="attrs"
        :value="computedValue"
        @selected="onSelect"
    />
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import {fr as DatepickerFrLanguage} from 'vuejs-datepicker/dist/locale';
    import moment from "moment";

    export default {
        components: {
            'datepicker': Datepicker,
        },

        props: {
            calendarButton: {
                type: Boolean,
                required: false,
                default: true,
            },
            calendarButtonIcon: {
                type: String,
                required: false,
                default: 'fad fa-calendar-alt fa-lg',
            },
            icon: {
                type: String,
                required: false,
            },
            value: {
                required: false,
            }
        },

        data() {
            return {
                datepickerFrLanguage: DatepickerFrLanguage,
            };
        },

        computed: {
            listeners() {
                const { input, ...listeners } = this.$listeners;
                return listeners;
            },

            attrs() {
                const { rows, ...attrs } = this.$attrs;
                return attrs;
            },

            computedValue() {
                if (this.value) {
                    return moment(this.value).toDate();
                }
                return null;
            },
        },

        methods: {
            showCalendar() {
                this.$refs.datepicker.showCalendar();
            },

            close() {
                this.$refs.datepicker.close();
            },

            onSelect(selectedDate) {
                this.$emit('input', selectedDate);
            },

            customFormatter(date) {
                return moment(date).format('DD MMMM YYYY');
            }
        },
    }
</script>

<style lang="scss">
    .vdp-datepicker {
        $green: #2ecc71;
        $orange: #f1c40f;
        $red: #e74c3c;

        .cell {
            padding: 0 !important;
        }

        .cell.day span {
            border-radius: 20px;
        }

        .cell.day.today span {
            border-radius: 0;
            transform: scale(1);
        }

        .vdp-datepicker__calendar .cell.selected {
            background: transparent;
        }

        .cell.day span {
            display: block;
            width: 100%;
            height: 100%;
            line-height: 37px;
        }

        .cell.day:not(.disabled) .day-green {
            border: 2px solid $green;
        }

        .cell.day:not(.disabled) .day-orange {
            border: 2px solid $orange;
        }

        .cell.day:not(.disabled) .day-red {
            border: 2px solid $red;
        }

        .cell.day:not(.disabled):hover {
            border: 1px solid transparent;
        }

        .cell.day:not(.disabled):hover .day-green {
            background-color: $green;
        }

        .cell.day:not(.disabled):hover .day-orange {
            background-color: $orange;
        }

        .cell.day:not(.disabled):hover .day-red {
            background-color: $red;
        }

        .cell.day.selected .day-green {
            background-color: $green;
        }

        .cell.day.selected .day-orange {
            background-color: $orange;
        }

        .cell.day.selected .day-red {
            background-color: $red;
        }

        .cell.day.disabled:hover {
            cursor: not-allowed;
        }

        .cell.day.disabled.selected .day-green {
            background-color: desaturate($green, 50%);
        }

        .cell.day.disabled.selected .day-orange {
            background-color: desaturate($orange, 50%);
        }

        .cell.day.disabled.selected .day-red {
            background-color: desaturate($red, 50%);
        }

        .cell.day.disabled .day-green {
            border: 2px solid desaturate($green, 50%);
        }

        .cell.day.disabled .day-orange {
            border: 2px solid desaturate($orange, 50%);
        }

        .cell.day.disabled .day-red {
            border: 2px solid desaturate($red, 50%);
        }
    }
</style>
